angular
  .module 'filters'
  .filter 'membershipPlanJoiningFeeFilter', ($rootScope, $filter) ->
    (costUpfront, currency) ->
      if costUpfront > 0
        symbol = currency || $rootScope.gym.currency_symbol
        $filter('currency')(costUpfront, symbol)
      else
        "No initial payment"
